import { IdCardType } from '../../../generated/globalTypes';

export const documentType = [
  { label: 'KTP', value: IdCardType.KTP },
  { label: 'SIM', value: IdCardType.SIM },
  { label: 'Passport', value: IdCardType.PASSPORT },
];
